import React, { useContext, useState } from 'react';
import { Input } from 'antd';
import useCarouselUrlHook from './CarouselUrl.hook';
import { AppContext } from 'App.context';
import styles from './UrlCarousel.styles';
import HotelsEditor from '../HotelsEditor/HotelsEditor';

export default function UrlCarousel({ paperlessCarouselUrl, hotel }) {
  const {
    appActions: { translate },
  } = useContext(AppContext);
  const { state, actions } = useCarouselUrlHook({ hotel });

  const [carouselUrl, setCarouselUrl] = useState(paperlessCarouselUrl || '');

  return (
    <div style={{ flex: 1 }}>
      <div style={styles.description}>{translate('appearence.carouselUrl')}</div>

      <div style={{ marginBottom: 16 }}>
        <Input
          placeholder={translate('appearence.carouselInput')}
          value={carouselUrl}
          onChange={e => setCarouselUrl(e.target.value)}
          style={{ width: '70%', marginRight: 8 }}
        />
      </div>

      <HotelsEditor
        currentHotel={state.hotel}
        appearanceData={carouselUrl}
        onCopyToHotels={actions.copyToHotels}
        label={translate('appearence.applyImagesSliderHotels')}
        labelSave={translate('save')}
      />
    </div>
  );
}
